<template>
  <div role="button">
    <div class="caption font-weight-bold" v-if="label">
      {{ label }}
      <span class="red--text" v-if="rules"><b>*</b></span>
    </div>
    <v-avatar :tile="!rounded" :width="width || size" :height="height || size">
      <div v-if="link || (images && images.length)">
        <div v-if="readonly">
          <a
            v-if="videoLink"
            :href="Host + videoLink.replace('.m3u8', '.mp4')"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              :style="{
                width: `${width || size}px`,
                height: `${height || size}px`,
              }"
              :src="Host + imgs[0]"
              @click="!readonly && $refs.input.click()"
            />
          </a>
          <viewer v-else :images="imgs">
            <img
              v-for="i in imgs"
              :key="i"
              :src="Host + i"
              :style="{
                width: `${width || size}px`,
                height: `${height || size}px`,
              }"
            />
          </viewer>
        </div>
        <div v-else>
          <img
            :style="{
              width: `${width || size}px`,
              height: `${height || size}px`,
            }"
            :src="Host + link"
            @click="!readonly && $refs.input.click()"
          />
          <div class="img-icon">
            <v-icon color="grey">{{ icon || "mdi-camera" }}</v-icon>
          </div>
        </div>
      </div>
      <div
        v-else
        :class="icon ? '' : 'avatar-frame'"
        :style="{ width: `${width || size}px`, height: `${height || size}px` }"
        @click="!readonly && $refs.input.click()"
      >
        <v-icon color="primary">{{ icon || "mdi-camera" }}</v-icon>
      </div>
    </v-avatar>
    <div class="file-upload">
      <v-text-field required :rules="rules" :value="check" readonly />
      <input type="file" accept="image/*" ref="input" @change="_fnUpload" />
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "link",
    event: "change",
  },
  props: {
    link: String,
    rules: Array,
    label: String,
    readonly: Boolean,
    images: Array,
    icon: String,
    rounded: Boolean,
    size: {
      type: Number,
      default: 80,
    },
    width: Number,
    height: Number,
    videoLink: String,
  },
  data() {
    return {
      imgs: [],
      check: "",
    };
  },
  created() {
    this.imgs = this.link ? [this.link] : this.images ? this.images : [];
    this.check = this.link;
  },
  methods: {
    async _fnUpload() {
      const { code, message, data } = await this.Api.upload({
        url: "/v1/admin/image",
        file: this.$refs.input.files[0],
        name: this.$refs.input.files[0].name,
      });
      if (code == 200) {
        this.check = data.link;
        this.$emit("change", data.link);
        this.fnNotificationView({ type: "success", message });
      } else {
        this.fnNotificationView({ type: "error", message });
      }
      // const image = new Image();
      // image.src = URL.createObjectURL(this.$refs.input.files[0]);
      // image.onload = () => {
      //   const canvas = document.createElement("canvas");
      //   canvas.width = image.width;
      //   canvas.height = image.height;
      //   const ctx = canvas.getContext("2d");
      //   ctx.drawImage(image, 0, 0);
      //   canvas.toBlob(
      //     async (file) => {
      //       const { code, message, data } = await this.Api.upload({
      //         url: "/v1/admin/image",
      //         file,
      //         name: this.$refs.input.files[0].name,
      //       });
      //       if (code == 200) {
      //         this.check = data.link;
      //         this.$emit("change", data.link);
      //       } else {
      //         this.fnNotificationView({ type: "error", message });
      //       }
      //     },
      //     "image/jpeg",
      //     0.75
      //   );
      // };
    },
  },
};
</script>

<style scoped>
.avatar-frame {
  border: 2px dashed #009688;
  display: flex;
  justify-content: center;
}

.file-upload {
  display: none;
}

.img-icon {
  position: absolute;
}
</style>
